import { format } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

/** The server sends `timezone` only when the event pins one; otherwise the browser zone applies. */
export function formatInEventZone(date: Date | string, timezone: string | null | undefined, pattern: string): string {
  return timezone ? formatInTimeZone(date, timezone, pattern) : format(new Date(date), pattern)
}
